import DonateCauseBox from '../../components/DonateCauseBox';
import './DonateCause.css';

function DonateCause() {
  const donateCauseContent = [
    {
      id: 0,
      title: 'Get a Woman back on her feet Post - Covid',
      body: 'We train women from vulnerable communities to be proficient office assistants.',
      buttonTitle: '3500',
    },
    {
      id: 1,
      title: 'Create Powerful Woman Changemakers.',
      body: 'Support livelihood training of 1 women and she will support 4 people of her family with the income.',
      buttonTitle: '5000',
    },
    {
      id: 2,
      title:
        'You could give a life back to rescued victim of human trafficking.',
      body: 'When we say your donation  are life changing, we really mean it. ',
      buttonTitle: '75',
    },
  ];
  return (
    <div className='donate_cause_main'>
      <h1 style={{ marginBottom: '30px' }}>Donate for a Cause</h1>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          padding: '0 50px',
        }}>
        {donateCauseContent?.map((item, index) => {
          return (
            <DonateCauseBox
              key={index}
              title={item?.title}
              body={item?.body}
              buttonTitle={item?.buttonTitle}
            />
          );
        })}
      </div>
    </div>
  );
}

export default DonateCause;
